module.exports = {
  title: 'Scrollable Bottom Sheet with Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2023-10-11',
  slug: 'scrollable-bottom-sheet',
  tags: ['reanimated', 'gesture-handler'],
};
